// extracted by mini-css-extract-plugin
module.exports = {"slide":"_timeout_slide_1Jyfi","slide-reverse":"_timeout_slide-reverse_2Xmp2","title":"_timeout_title_QmghM"};